import React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DetailsValue } from "./DetailsPage";
import { SearchDatabase } from "../search/SearchPage";
import { setSearchTermParam } from "../search/useSearchSubmit";

export enum SearchDB {
  ls2pac = "ls2pac",
  // TODO extend as other databases are reimplemented
}

export enum DetailsValueLinkType {
  author = "author",
  title = "title",
  subject = "subject",
  seriestitle = "seriestitle",
  eresource = "eresource",
}

// TODO there may be additional types needed for "authorsuggestion", "isbn", "rss", "callNumber"
type SearchType = DetailsValueLinkType | "tag";

const SearchTermPrefix: Record<SearchType, string | null> = {
  [DetailsValueLinkType.author]: "au",
  [DetailsValueLinkType.title]: "ti",
  [DetailsValueLinkType.subject]: "su",
  [DetailsValueLinkType.seriestitle]: "se",
  [DetailsValueLinkType.eresource]: null, // unused
  tag: "tag", // extended for tag linking
};

export const getSearchTerm = (
  value: string,
  type: SearchType | null = null
) => {
  const prefix = type ? SearchTermPrefix[type] : null;
  return !!prefix ? `${prefix}:"${value}"` : value;
};

export const getSearchURL = (
  value: string,
  type: SearchType | null = null,
  source: SearchDatabase = SearchDatabase.LS,
  currentParams: URLSearchParams = new URLSearchParams()
) => {
  const term = getSearchTerm(value, type);
  const searchParams = setSearchTermParam(currentParams, term);
  return `/search/${source}?${searchParams.toString()}`;
};

export const DetailsValueLink = ({
  value,
  linkType,
  linkValue,
}: DetailsValue) => {
  if (linkType === DetailsValueLinkType.eresource) {
    return (
      <Link href={linkValue} target="_blank" rel="noopener noreferrer">
        {value}
      </Link>
    );
  }
  return (
    <RouterLink to={getSearchURL(linkValue, linkType)}>{value}</RouterLink>
  );
};
